// Runtime configuration accessor
// Values are injected at container startup via window.__CONFIG__

const getConfig = () => {
  // Check if runtime config exists AND has actual values (not empty strings)
  if (typeof window !== 'undefined' && window.__CONFIG__ && window.__CONFIG__.REACT_APP_API_URL) {
    return window.__CONFIG__;
  }
  // Fallback for build-time (tests, local dev)
  return {
    REACT_APP_API_URL: process.env.REACT_APP_API_URL || ''
  };
};

export const config = getConfig();
export const apiUrl = config.REACT_APP_API_URL;
